export const API_BASE_URL = (process.env && process.env.REACT_APP_API && (!process.env.NODE_ENV || process.env.NODE_ENV !== 'production'))?`${process.env.REACT_APP_API}/api/v1`:'/api/v1';

export const LOGIN = {
    URL: `${API_BASE_URL}/admin-login`,
};

export const GET_USERS = {
    URL: `${API_BASE_URL}/users-list`,
};

export const GET_REPORT_USERS = {
    URL: `${API_BASE_URL}/reported-users`,
};

export const GET_ANALYTICS = {
    URL: `${API_BASE_URL}/dashboard-data`,
};

export const GET_GOOGLE_ANALYTICS = {
    URL: `${API_BASE_URL}/google-analytics`,
};

export const GET_GOOGLE_ANALYTICS_GRAPH = {
    URL: `${API_BASE_URL}/google-analytics-graph`,
};

export const GET_REPORTED_POSTS = {
    URL: `${API_BASE_URL}/reported-posts`,
};

export const GET_SEARCHES = {
    URL: `${API_BASE_URL}/searches`,
};

export const USERS_GROUPS = {
    URL: `${API_BASE_URL}/group`,
};

export const GROUPS_PERMISSIONS = {
    URL: `${API_BASE_URL}/group-permissions`,
};

export const GET_ADMIN_USERS = {
    URL: `${API_BASE_URL}/admin-users-list`,
};

export const ASSIGN_USER_GROUPS = {
    URL: `${API_BASE_URL}/assign-groups`,
};

export const USER_PROFILE = {
    URL: `${API_BASE_URL}/user-profile`,
};

export const GET_FAVOURITES = {
    URL: `${API_BASE_URL}/favourites`,
};

export const GET_TOP_SEARCHES = {
    URL: `${API_BASE_URL}/top-searches`,
};

export const SUSPEND_ACCOUNT = {
    URL: `${API_BASE_URL}/suspend-account`,
};

export const REPORTED_BY = {
    URL: `${API_BASE_URL}/reported-by`,
};
export const VIEWED_BY = {
    URL: `${API_BASE_URL}/viewed-by`,
};
export const POST_DETAILS = {
    URL: `${API_BASE_URL}/reported-post-details`,
};
export const DELETE_POST = {
    URL: `${API_BASE_URL}/delete-post`,
};
export const UPDATE_PROFILE = {
    URL: `${API_BASE_URL}/update-profile`,
};
export const ADD_USER = {
    URL: `${API_BASE_URL}/create-user`,
};
export const GET_LOGIN_DATA = {
    URL: `${API_BASE_URL}/get-login-data`,
};

export const GROUP_DROPDOWN = {
    URL: `${API_BASE_URL}/group-dropdown`,
};

export const CHANGE_PASSWORD = {
    URL: `${API_BASE_URL}/change-password`,
};
export const GET_ROOMS = {
    URL: `${API_BASE_URL}/chat-rooms`,
};
export const GET_MESSAGES = {
    URL: `${API_BASE_URL}/chat-messages`,
};
export const ACCESS_REQUEST = {
    URL: `${API_BASE_URL}/conversation-access-request`,
};
export const REVOKE_ACCOUNT = {
    URL: `${API_BASE_URL}/revoke-suspended-account`,
};
export const RESET_PASSWORD = {
    URL: `${API_BASE_URL}/reset-password`,
};

export const USERS_PERMISSIONS = {
    URL: `${API_BASE_URL}/user-permissions`,
};

export const FAILED_URLS = {
    URL: `${API_BASE_URL}/failed-urls`,
};

export const API_DOCUMENTATION = {
    URL: `${API_BASE_URL}/api-documentation`,
};

export const SWISSEARCH_API_DOCUMENTATION = {
    URL: `${API_BASE_URL}/swissearch-api-documentation`,
};

export const MOBILE_API_DOCUMENTATION = {
    URL: `${API_BASE_URL}/mobile-api-documentation`,
};

export const GET_USERS_LOCATIONS = {
    URL: `${API_BASE_URL}/users-locations`,
};

export const SETTINGS = {
    URL: `${API_BASE_URL}/settings`,
};

export const CAMPAIGNS = {
    URL: `${API_BASE_URL}/campaigns`,
};
export const CAMPAIGNS_DATA = {
    URL: `${API_BASE_URL}/campaigns-details`,
};

export const CAMPAIGNS_CHARGES = {
    URL: `${API_BASE_URL}/campaign-charges`,
};

export const INTEREST = {
    URL: `${API_BASE_URL}/campaign-interests`,
};
export const GET_TRANSACTION_HISTORY = {
    URL: `${API_BASE_URL}/transaction-history`,
};
export const GET_CAMPAIGNS_ANALYTICS = {
    URL: `${API_BASE_URL}/campaign-analytics`,
};
export const GET_TRANSACTIONS_GRAPH_DATA = {
    URL: `${API_BASE_URL}/transaction-graph-data`,
};

export const GET_ACTIVE_CAMPAIGNS_MAP_DATA = {
    URL: `${API_BASE_URL}/active-campaign-locations`,
};

export const GET_FOLLOWERS = {
    URL: `${API_BASE_URL}/followers`,
};
export const GET_FOLLOWING = {
    URL: `${API_BASE_URL}/following`,
};

export const GET_FAILED_URLS_DATA = {
    URL: `${API_BASE_URL}/failed-urls-data`,
};

export const CHANGE_ENRICHMENT_SETTING = {
    URL: `${API_BASE_URL}/change-enrichment-settings`,
};

export const GET_FAILED_URLS_FREQUENCY = {
    URL: `${API_BASE_URL}/failed-urls-frequency`,
};

export const SAVE_DASHBOARD_WIDGET = {
    URL: `${API_BASE_URL}/save-dashboard-widget`,
};
export const GET_DASHBOARD_WIDGET = {
    URL: `${API_BASE_URL}/dashboard-widget`,
};

export const CHANGE_APP_PASSWORD = {
    URL: `${API_BASE_URL}/change-app-password`,
};
export const VERIFY_OTP = {
    URL: `${API_BASE_URL}/verify-auth`,
};
export const RESEND_OTP = {
    URL: `${API_BASE_URL}/resend-otp`,
};
export const UPDATE_AUTO_FOLLOW = {
    URL: `${API_BASE_URL}/make-user-autofollow`,
};

export const APP_VERSION_SETTING = {
    URL: `${API_BASE_URL}/app-version-setting`,
};

export const RSS_GENERATE = {
    URL: `${API_BASE_URL}/rss/generate`,
};

export const RSS_INFO = {
    URL: `${API_BASE_URL}/rss/info`,
};

export const RSS_TOGGLE = {
    URL: `${API_BASE_URL}/rss/toggle`,
};




